import { mount } from "@vue/test-utils";
import InputTooltip from "@/components/core/custom/InputTooltip";

describe("InputTooltip test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(InputTooltip);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component InputTooltip", () => {
    expect(wrapper).toBeDefined();
  });
});
